import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LatLng } from 'leaflet';
import { plantIcon, siteBeginIcon, siteEndIcon, vehicleLoadedIcon } from '../../../../projects/qpoint-maps/src/lib/components/map/default-map-icons';

import { MapMarkerComponent, QPointMapPolygon, QPointMapPolyline } from '../../../../projects/qpoint-maps/src/public_api';
import { MapComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map.component";
import { MapPolylineComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map-polyline/map-polyline.component";
import { MapPolygonComponent } from "../../../../projects/qpoint-maps/src/lib/components/map/map-polygon/map-polygon.component";

@Component({
    selector: 'app-map-qsite-project-test',
    imports: [
        CommonModule,
        MapComponent,
        MapMarkerComponent,
        MapPolylineComponent,
        MapPolygonComponent
    ],
    templateUrl: './map-qsite-project-test.component.html',
    styleUrls: ['./map-qsite-project-test.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapQSiteProjectTestComponent {
  zoomPosition: google.maps.ControlPosition = google.maps.ControlPosition.RIGHT_TOP;
  center = new LatLng(42, 13.5);

  mapMarkerOptions = [
    { position: new LatLng(46.69407594, 16.11388167), icon: siteBeginIcon() },
    { position: new LatLng(46.69407594, 16.11398167), icon: siteEndIcon() },
    { position: new LatLng(46.69412594, 16.11276567), icon: plantIcon() },
    { position: new LatLng(46.69417594, 16.11276567), icon: vehicleLoadedIcon() }
  ];

  siteArea: QPointMapPolygon = {
        type: 'Polygon',
        coordinates: [[
          [
            16.11378167,
            46.69407594
          ],
          [
            16.11426662,
            46.69420077
          ],
          [
            16.11446662,
            46.69385111
          ],
          [
            16.11385168,
            46.69362628
          ],
          [
            16.11378167,
            46.69407594
          ]
        ]]
    };

    plantArea: QPointMapPolygon = {
      type: 'Polygon',
      coordinates: [[
        [
          16.11286567,
          46.69407594
        ],
        [
          16.11266567,
          46.69407594
        ],
        [
          16.11266567,
          46.69417594
        ],
        [
          16.11276567,
          46.69417594
        ],
        [
          16.11286567,
          46.69407594
        ]
      ]]
  };

  pavingPath: QPointMapPolyline = {
      type: 'LineString',
      coordinates: [
        [
          16.11388167,
          46.69407594
        ],
        [
          16.11398167,
          46.69407594
        ]
      ]
  };
}
